module.exports = __webpack_public_path__ + "images/frontpage_icon@3x.png?790b5e0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_icon@3x.png
// module id = 650
// module chunks = 7